import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { SharedService } from '../../../../../shared/shared.service';
import { MethodOfPaymentService } from '../../method-of-payment.service';

@Component({
  selector: 'app-method-of-payment',
  templateUrl: './method-of-payment.component.html',
  styleUrls: ['./method-of-payment.component.css']
})
export class MethodOfPaymentComponent implements OnInit {

  dataSource;
  sessionId = sessionStorage.getItem('com-session-id');

  constructor(
    public sharedService: SharedService,
    private httpClient: HttpClient,
    public payment: MethodOfPaymentService
  ) { }

  ngOnInit() {
    this.sharedService.loadingActive = true;
    // tslint:disable-next-line:max-line-length
    this.httpClient.get<any>(`${this.sharedService.URL}/dbMethodOfPayment?SessionID=${this.sessionId}&Search=*`).subscribe(Response => {
      this.dataSource = Response.dbMethodOfPayment_response.view;
      this.sharedService.loadingActive = false;
    });
    this.sharedService.loadingActive = false;
  }

  clickEdit(data) {
    this.payment.setPayment(0);
    sessionStorage.setItem('payment-id', data);
  }
  clickNew() {
    this.payment.setPayment(1);
  }

}
